module.exports = __webpack_public_path__ + "assets/热度.8c035ff9.svg";